module.exports = __webpack_public_path__ + "img/theCover_13.0d24799d.jpg";